var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#4CAF50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.233 4.5H16.9347V6.44744H14.9872V7.74574H16.9347V9.69318H18.233V7.74574H20.1804V6.44744L18.233 6.44744V4.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8234 5.14915C10.9956 5.14915 11.1607 5.21754 11.2825 5.33928L19.7214 13.7782C19.9749 14.0317 19.9749 14.4427 19.7214 14.6962L14.7971 19.6205C14.5436 19.874 14.1326 19.874 13.8791 19.6205L5.44013 11.1816C5.31839 11.0599 5.25 10.8948 5.25 10.7226L5.25 6.44744C5.25 5.73041 5.83127 5.14915 6.5483 5.14915L10.8234 5.14915ZM7.52202 8.39489C8.05979 8.39489 8.49574 7.95894 8.49574 7.42116C8.49574 6.88339 8.05979 6.44744 7.52202 6.44744C6.98425 6.44744 6.5483 6.88339 6.5483 7.42116C6.5483 7.95894 6.98425 8.39489 7.52202 8.39489Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.233 4.5H16.9347V6.44744H14.9872V7.74574H16.9347V9.69318H18.233V7.74574H20.1804V6.44744L18.233 6.44744V4.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8234 5.14915C10.9956 5.14915 11.1607 5.21754 11.2825 5.33928L19.7214 13.7782C19.9749 14.0317 19.9749 14.4427 19.7214 14.6962L14.7971 19.6205C14.5436 19.874 14.1326 19.874 13.8791 19.6205L5.44013 11.1816C5.31839 11.0599 5.25 10.8948 5.25 10.7226L5.25 6.44744C5.25 5.73041 5.83127 5.14915 6.5483 5.14915L10.8234 5.14915ZM7.52202 8.39489C8.05979 8.39489 8.49574 7.95894 8.49574 7.42116C8.49574 6.88339 8.05979 6.44744 7.52202 6.44744C6.98425 6.44744 6.5483 6.88339 6.5483 7.42116C6.5483 7.95894 6.98425 8.39489 7.52202 8.39489Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.233 4.5H16.9347V6.44744H14.9872V7.74574H16.9347V9.69318H18.233V7.74574H20.1804V6.44744L18.233 6.44744V4.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8234 5.14915C10.9956 5.14915 11.1607 5.21754 11.2825 5.33928L19.7214 13.7782C19.9749 14.0317 19.9749 14.4427 19.7214 14.6962L14.7971 19.6205C14.5436 19.874 14.1326 19.874 13.8791 19.6205L5.44013 11.1816C5.31839 11.0599 5.25 10.8948 5.25 10.7226L5.25 6.44744C5.25 5.73041 5.83127 5.14915 6.5483 5.14915L10.8234 5.14915ZM7.52202 8.39489C8.05979 8.39489 8.49574 7.95894 8.49574 7.42116C8.49574 6.88339 8.05979 6.44744 7.52202 6.44744C6.98425 6.44744 6.5483 6.88339 6.5483 7.42116C6.5483 7.95894 6.98425 8.39489 7.52202 8.39489Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.233 4.5H16.9347V6.44744H14.9872V7.74574H16.9347V9.69318H18.233V7.74574H20.1804V6.44744L18.233 6.44744V4.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8234 5.14915C10.9956 5.14915 11.1607 5.21754 11.2825 5.33928L19.7214 13.7782C19.9749 14.0317 19.9749 14.4427 19.7214 14.6962L14.7971 19.6205C14.5436 19.874 14.1326 19.874 13.8791 19.6205L5.44013 11.1816C5.31839 11.0599 5.25 10.8948 5.25 10.7226L5.25 6.44744C5.25 5.73041 5.83127 5.14915 6.5483 5.14915L10.8234 5.14915ZM7.52202 8.39489C8.05979 8.39489 8.49574 7.95894 8.49574 7.42116C8.49574 6.88339 8.05979 6.44744 7.52202 6.44744C6.98425 6.44744 6.5483 6.88339 6.5483 7.42116C6.5483 7.95894 6.98425 8.39489 7.52202 8.39489Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.a04afd5bde9af54f6b2b4c348cd1acb4.svg";
export { ForwardRef as ReactComponent };